import { axios, API_ROUTES } from "@/config";

export default {
  async getAll(params) {
    let result = await axios.get(`${API_ROUTES.favorite.get}`, {
      params: params,
    });

    return result;
  },
};
